<template>
    <div class="activityDetailsFivePage">
        <van-loading v-if="loading"
                     type="spinner"
                     color="#FFFFFF"
                     vertical>加载中...</van-loading>
        <div v-if="!loading"
             class="content">
            <div class="img_bg">
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/488feaa1008b4dd2bc407d865fcb28b3.png"
                     alt="">
            </div>
            <div class="activity_rule"
                 @click="handleViewRule">活动规则</div>
            <div class="tabBox">
                <div @click="handleCheckTab(101)"
                     :class="['tabItem', {'cur_font_color': current == 1}]">佣金加码</div>
                <div @click="handleCheckTab(201)"
                     :class="['tabItem', {'cur_font_color': current == 2}]">组队冲榜</div>
                <div :class="['tab_bg', {'abs_left': current == 2}]"></div>
            </div>
            <div class="activity1"
                 v-if="current == 1"
                 :style="{'padding-bottom': '0.4rem'}">
                <div class="subsidy_user">
                    <div class="subsidy_box">
                        <div class="act_date">
                            <div :class="['item_date',{'currentDateClass': currentId == item.id}]"
                                 :style="{'width': 100/dateArr1.length+'%'}"
                                 v-for="(item, index) in dateArr1"
                                 :key="index"
                                 @click="handleCheckDate(item)">
                                <span>{{item.actDate}}</span>
                                <img v-if="!item.isBegin"
                                     class="no_begin"
                                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/63a97fa3da584e2591c3e02461e3827c.png"
                                     alt="">
                            </div>
                        </div>
                        <div class="all_activity1"
                             v-for="(item, index) in activityArr1"
                             :key="index">
                            <div class="order_standard_box"
                                 v-if="currentId == item.id">
                                <div class="title_box">
                                    <div>本阶段推广<br />订单量达</div>
                                    <span v-for="(item2, index2) in item.bonusCfg"
                                          :key="index2">
                                        (日均<span>{{item2.bonusLevelName || 0}}</span>单)<br />
                                        达成<span>{{item2.orderCountMinRequired || 0}}</span>单
                                    </span>
                                </div>
                                <div class="progress_box">
                                    <div class="progress_all"></div>
                                    <div class="progress_in"
                                         :style="{width: progressIn + '%'}"></div>
                                    <div class="stage_box">
                                        <div :class="['stage','stageall',{'curStage': commissionOrderCount>=item.bonusCfg[0].orderCountMinRequired}]"></div>
                                        <div :class="['stage',{'curStage': commissionOrderCount>=item.bonusCfg[1].orderCountMinRequired}]"></div>
                                        <div :class="['stage',{'curStage': commissionOrderCount>=item.bonusCfg[2].orderCountMinRequired}]"></div>
                                    </div>
                                </div>
                                <div class="standard_box">
                                    <span class="tip_box">
                                        <div class="station_tip"><span>用来占位</span></div>
                                        <span>每单补贴</span>
                                        <p v-if="currentId == 111230502 || currentId == 111230503">达门槛送卡组</p>
                                    </span>
                                    <div v-for="(item2, index2) in item.bonusCfg"
                                         :key="index2">
                                        <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/def97148efd74d698258847aaa4eed88.png"
                                             alt="">
                                        <p class="p1"><span>{{item2.bonusAmount || 0}}</span>元</p>
                                        <p class="p2">1单补贴</p>
                                        <p class="p3">达成{{item2.orderCountMinRequired}}单</p>
                                        <div class="subsidy_tip"
                                             v-if="item2.prizeCard"><span>{{item2.prizeCard}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="user_login_box">
                            <div class="user_con">
                                <div class="user_box">
                                    <img :src="token ? userInfo.avatarUrl : require('../../sprite/no_login.png')"
                                         alt="">
                                    <div class="my_order_info"
                                         v-if="!token">
                                        <div class="no_login_tip">未登录</div>
                                        <div class="my_order">我的订单量：登录后可查看</div>
                                    </div>
                                    <div class="my_order_info"
                                         v-if="token">
                                        <div class="no_join"
                                             v-if="!isJoinActivity1">您还未报名该活动</div>
                                        <div :class="['my_order',{'weightColor': isJoinActivity1}]"
                                             v-if="isJoinActivity1">我的订单量：{{commissionOrderCount}}</div>
                                        <div class="order_tip"
                                             v-if="isJoinActivity1">
                                            <span v-if="commissionOrderCount < bonusCfg[0].orderCountMinRequired">暂未达到补贴门槛</span>
                                            <span
                                                  v-if="commissionOrderCount >= bonusCfg[0].orderCountMinRequired && commissionOrderCount < bonusCfg[1].orderCountMinRequired">预计单笔订单补贴¥{{bonusCfg[0].bonusAmount || 0}}</span>
                                            <span
                                                  v-if="commissionOrderCount >= bonusCfg[1].orderCountMinRequired && commissionOrderCount < bonusCfg[2].orderCountMinRequired">预计单笔订单补贴¥{{bonusCfg[1].bonusAmount || 0}}</span>
                                            <span v-if="commissionOrderCount >= bonusCfg[2].orderCountMinRequired">预计单笔订单补贴¥{{bonusCfg[2].bonusAmount || 0}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="login_btn"
                                     v-if="!token"
                                     @click="goLogin">立即登录</div>
                                <div class="join_btn"
                                     v-if="token && !isJoinActivity1"
                                     @click="goJoin1">立即报名</div>
                            </div>
                            <div class="login_tip"
                                 v-if="isJoinActivity1 && commissionOrderCount >= bonusCfg[0].orderCountMinRequired && isActivityEnd1 && !activityInfo1.isSendPrize">
                                补贴金¥{{ subsidyMoney }}，预计发放时间2023年5月31日23:59前
                            </div>
                            <div class="login_tip"
                                 v-if="isJoinActivity1 && commissionOrderCount >= bonusCfg[0].orderCountMinRequired && isActivityEnd1 && activityInfo1.isSendPrize">¥{{ subsidyMoney }}补贴已发放<span
                                      @click="goEventRewards">&nbsp;&nbsp;&nbsp;&nbsp;查看详情></span></div>
                        </div>
                    </div>
                    <div class="product_box"
                         v-if="productList1.length > 0">
                        <img class="title_img"
                             src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/35e71a00169c4d909dcf3b31145ee44d.png"
                             alt="">
                        <ul>
                            <li v-for="(item, index) in productList1"
                                :key="index"
                                @click="shareHandle(item)">
                                <img class="item_img"
                                     :src="item.productImage"
                                     alt="">
                                <div class="right_des">
                                    <div class="title">{{item.productName}}</div>
                                    <div class="des_bottom_box">
                                        <div class="money">
                                            <div class="price">¥<span>{{item.salePrice || 0}}</span></div>
                                            <div class="commision">佣金¥{{item.oneCommission || 0}}</div>
                                        </div>
                                        <div class="promote_now_btn">立即推广</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="activity_explain">
                        <div class="explain">
                            <p>1、参与方式：本活动只对报名大使进行结算，请先点击报名</p><br>
                            <p>2、统计范围：指定补贴品为芒果TV会员年卡、芒果超级乐享卡、芒果TV全屏会员连续包年卡、芒果TV会员连续包年卡赠喜马拉雅年卡，仅计算一级订单（退单/无效订单不计入）</p><br>
                            <p>3、大使获得的现金补贴＝个人订单*补贴金，按结束时单量所在档位补贴，每阶段仅可以领取一次，不叠加领取；不同活动时段奖金可叠加领取（详见规则）</p>
                        </div>
                    </div>
                    <div class="community_box">
                        <div class="community_left">
                            <img class="qdcode"
                                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d39ede2f60064c91bf3f6a93ee4a17be.png"
                                 alt="">
                            <p>芒果推广大使公众号</p>
                            <p>最新活动信息</p>
                            <p>不定时芒果福利</p>
                        </div>
                        <div class="community_right">
                            <img class="qdcode"
                                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/40d9f55864bf42edaab5876745036aae.jpg"
                                 alt="">
                            <p>M-Club社群</p>
                            <p>最快赚钱攻略</p>
                            <p>最全官方培训</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="activity2"
                 v-if="current == 2">
                <div class="main_body_box">
                    <div class="team_box">
                        <img class="guide_img"
                             v-if="!isJoinActivity2"
                             src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/c6ddb160c53f4616add7fc61f374b1ea.png"
                             alt=""
                             @click="_showCreatTeamPopup">
                        <div class="created_team"
                             v-if="token && isJoinActivity2">
                            <img class="title_img"
                                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/e39bf4bbc82c429d969cd0ceca454acc.png"
                                 alt="">
                            <div class="invited_desc">
                                <van-loading v-if="Teamloading"
                                             type="spinner"
                                             color="#9CECB4"
                                             vertical
                                             class="team_loading">加载中...</van-loading>
                                <div v-if="!Teamloading">
                                    <div class="sales_rangking"
                                         @click="showSalesRankPopup = true">销量排行</div>
                                    <div class="avatar_desc">
                                        <img :src="teamInfos.groupAvatarUrl"
                                             alt="">
                                        <span>{{teamInfos.groupName}}</span>
                                    </div>
                                    <div class="team_desc">
                                        <div class="item_column">
                                            <p>团队总单量</p>
                                            <p>{{teamInfos.groupCommissionOrderNum || 0}}单</p>
                                        </div>
                                        <div class="item_column">
                                            <p>战队排名</p>
                                            <p v-if="teamInfos.rank">{{teamInfos.rank}}</p>
                                            <p v-if="!teamInfos.rank">未上榜</p>
                                        </div>
                                        <div class="item_column">
                                            <p>我的个人单量</p>
                                            <p>{{teamInfos.myCommissionOrderNum || 0}}单</p>
                                        </div>
                                        <div class="item_column">
                                            <p>预计获得奖金</p>
                                            <p v-if="teamInfos.prizeAmount">{{teamInfos.prizeAmount}}元</p>
                                            <p v-if="!teamInfos.prizeAmount">无奖励</p>
                                        </div>
                                    </div>
                                    <ul>
                                        <li v-for="(item, index) in teamInfos.groupMemberInfos"
                                            :key="index">
                                            <img :src="item.avatarUrl"
                                                 alt="">
                                            <p>{{item.nickName}}</p>
                                        </li>
                                        <li v-if="teamInfos.groupMemberInfos && teamInfos.groupMemberInfos.length==1">
                                            <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d63bacf604b74423b6eef859c9820776.png"
                                                 alt="">
                                        </li>
                                        <li v-if="teamInfos.groupMemberInfos && teamInfos.groupMemberInfos.length==1">
                                            <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d63bacf604b74423b6eef859c9820776.png"
                                                 alt="">
                                        </li>
                                        <li v-if="teamInfos.groupMemberInfos && teamInfos.groupMemberInfos.length==2">
                                            <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d63bacf604b74423b6eef859c9820776.png"
                                                 alt="">
                                        </li>
                                    </ul>
                                    <div :class="['invitied_friend_btn', {'disabledClass': teamInfos.groupMemberInfos && teamInfos.groupMemberInfos.length==3}]"
                                         @click="invitiedFriendHanled">邀请好友组队</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="desc_box">
                        <div class="act_date">
                            <div :class="['item_date',{'currentDateClass': currentId == item.id}]"
                                 :style="{'width': 100/dateArr2.length+'%'}"
                                 v-for="(item, index) in dateArr2"
                                 :key="index"
                                 @click="handleCheckDate(item)">
                                <span>{{item.actDate}}</span>
                                <img v-if="!item.isBegin"
                                     class="no_begin"
                                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/63a97fa3da584e2591c3e02461e3827c.png"
                                     alt="">
                            </div>
                        </div>
                        <div class="all_activity2"
                             v-for="(item, index) in activityArr2"
                             :key="index">
                            <div class="rank_desc"
                                 v-if="currentId == item.id">
                                <div class="ranking left_desc">
                                    <div class="price_desc"><span>{{item.groupPrizeCfgs[0].bonusAmount || 0}}</span><span>元</span></div>
                                    <p>（日均{{item.groupPrizeCfgs[0].bonusLevelName || 0}}单）<br>达成{{item.groupPrizeCfgs[0].orderCountMinRequired || 0}}单</p>
                                </div>
                                <div class="ranking right_desc">
                                    <div class="price_desc"><span>{{item.groupPrizeCfgs[1].bonusAmount || 0}}</span><span>元</span></div>
                                    <p>（日均{{item.groupPrizeCfgs[1].bonusLevelName || 0}}单）<br>达成{{item.groupPrizeCfgs[1].orderCountMinRequired || 0}}单</p>
                                </div>
                            </div>
                            <div class="rank_desc_bot"
                                 v-if="currentId == item.id">
                                <p>（日均{{item.groupPrizeCfgs[2].bonusLevelName || 0}}单）<br>达成{{item.groupPrizeCfgs[2].orderCountMinRequired || 0}}单</p>
                                <div class="price_desc"><span>{{item.groupPrizeCfgs[2].bonusAmount || 0}}</span><span>元</span></div>
                            </div>
                        </div>
                        <div class="tip">*仅组团成员可获得补贴</div>
                    </div>
                    <div class="product_box"
                         v-if="productList2.length > 0">
                        <img class="title_img"
                             src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/35e71a00169c4d909dcf3b31145ee44d.png"
                             alt="">
                        <ul>
                            <li v-for="(item, index) in productList2"
                                :key="index"
                                @click="shareHandle(item)">
                                <img class="item_img"
                                     :src="item.productImage"
                                     alt="">
                                <div class="right_des">
                                    <div class="title">{{item.productName}}</div>
                                    <div class="des_bottom_box">
                                        <div class="money">
                                            <div class="price">￥<span>{{item.salePrice || 0}}</span></div>
                                            <div class="commision">佣金¥{{item.oneCommission || 0}}</div>
                                        </div>
                                        <div class="promote_now_btn">立即推广</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="activity_explain">
                        <div class="explain">
                            <p>1、参与方式：本活动只对报名大使进行结算，请先创建您的队伍。若未报名且未被邀请进入团队，则不计入订单排行榜。</p><br>
                            <p>2、统计范围：指定活动品为芒果TV会员年卡、芒果超级乐享卡、芒果TV全屏会员连续包年卡、芒果TV会员连续包年卡赠喜马拉雅年卡 ，仅计算一级订单（退单/无效订单不计入）</p><br>
                            <p>3、活动期间团队订单排名前六名并且满足领取条件的情况下，即可获得对应奖励。</p><br>
                            <p>4、组队成功后，若团队订单达标，则团队内每人所得奖金=个人订单/团队总订单*团队所得奖金。 （详见规则）</p>
                        </div>
                    </div>
                    <div class="community_box">
                        <div class="community_left">
                            <img class="qdcode"
                                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d39ede2f60064c91bf3f6a93ee4a17be.png"
                                 alt="">
                            <p>芒果推广大使公众号</p>
                            <p>最新活动信息</p>
                            <p>不定时芒果福利</p>
                        </div>
                        <div class="community_right">
                            <img class="qdcode"
                                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/40d9f55864bf42edaab5876745036aae.jpg"
                                 alt="">
                            <p>M-Club社群</p>
                            <p>最快赚钱攻略</p>
                            <p>最全官方培训</p>
                        </div>
                    </div>
                    <!-- <div class="placard_box1"
                         v-if="isActivityEnd2 && !isPublicityTimeEnd">
                        <div class="tip">活动已结束</div>
                        <div class="time">发奖公示时间：{{publicityStartDate}}</div>
                    </div>
                    <div class="placard_box2"
                         v-if="isActivityEnd2 && isPublicityTimeEnd">
                        <span class="left">活动已结束，点击查看发奖公示</span>
                        <span class="right"
                              @click="goAwardPlacard">去查看</span>
                    </div> -->
                </div>
            </div>
            <Rule v-if="showRulePopup"
                  :isPromoteRuleShow="showRulePopup"
                  @closeRulePopup="handleCloseRulePopup"></Rule>
            <div class="joinDialog"
                 :class="isVisible ? 'showDialog' : 'hiddenDialog'">
                <div class="content">
                    <div class="joinIn">
                        <div class="title">
                            <div>
                                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d82109a544e04d9f8c66b50ca7a4604b.png"
                                     alt="">
                                <span>1.加入M-CLUB</span>
                            </div>
                            <span class="arr"></span>
                            <div>
                                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/647fe0c3922a4d499805f06f7ebed93c.png"
                                     alt="">
                                <span>2.分享售卡</span>
                            </div>
                            <span class="arr"></span>
                            <div>
                                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/2483fff2168f4fda8d9b2064da30175f.png"
                                     alt="">
                                <span>3.得返佣奖励</span>
                            </div>
                        </div>
                        <div class="conter">
                            <div class="user">
                                <img :src="userInfo && userInfo.avatarUrl"
                                     alt="">
                                <span>{{userInfo && userInfo.nickName}}</span>
                            </div>
                            <div class="tip">加入M-CLUB省心赚</div>
                            <div class="enterBtn"
                                 @click="createUserInfo">确认协议并成为推广大使</div>
                            <div class="agreement">我已同意以下协议：<span @click="viewAgreement('/serveAgreement')">《芒果TV M-CLUB芒果推广大使服务协议》</span><span @click="viewAgreement('/commissionAgreement')">《芒果TV
                                    M-CLUB芒果推广大使佣金与行为规则》</span></div>
                        </div>
                    </div>
                    <div class="close">
                        <van-icon size="34"
                                  color="#ffffff"
                                  name="close"
                                  @click="isVisible = false" />
                    </div>
                </div>
            </div>
            <!-- 商品海报 -->
            <ProductPoster v-if="showProductPopup"
                           :show="showProductPopup"
                           :shareProduct="shareProduct"
                           :userInfo="userInfo"
                           :activityInfo="activityInfo"
                           pageType="activity"
                           @closePopup="handleClose"></ProductPoster>
            <!-- 创建团队popup -->
            <van-popup v-model="showCreatTeamPopup"
                       class="creat_team_popup">
                <div class="creat_team_content">
                    <p>创建团队后，</p>
                    <p>不可退出组队是否同意创建？</p>
                    <div class="btn_box">
                        <div class="cancel_btn"
                             @click="showCreatTeamPopup = false">取消</div>
                        <div class="confirm_btn"
                             @click="creatTeamHandle">创建</div>
                    </div>
                </div>
                <img class="close_img"
                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/224a30e535b145428899581767bb2ec2.png"
                     alt=""
                     @click="showCreatTeamPopup = false">
            </van-popup>
            <!-- 邀请加入组队popup -->
            <van-popup v-model="showInvitedJoinPopup"
                       class="invited_join_popup">
                <img class="title_img"
                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/b42f84597eaf417faba396bc15b4c9b6.png"
                     alt="">
                <div class="invited_join_content">
                    <img class="invited_avatar"
                         :src="userInfo.avatarUrl"
                         alt="">
                    <p class="invited_nick">{{userInfo.nickName}}</p>
                    <p class="invited_tip">快加入我的团队吧</p>
                    <div class="invited_qrcode_box">
                        <img class="invited_qrcode"
                             :src="qrCode"
                             alt="">
                    </div>
                </div>
                <img class="close_img"
                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/224a30e535b145428899581767bb2ec2.png"
                     alt=""
                     @click="showInvitedJoinPopup = false">
            </van-popup>
            <!-- 团队销量排行popup -->
            <van-popup v-model="showSalesRankPopup"
                       class="sales_rank_popup"
                       position="bottom">
                <img class="close_img"
                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/224a30e535b145428899581767bb2ec2.png"
                     alt=""
                     @click="showSalesRankPopup = false">
                <img class="title_img"
                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/ca0ba5bea0c640cbb514f55d760314df.png"
                     alt="">
                <div class="sales_rank_content">
                    <div class="rank_box">
                        <img class="rank_grad_bg"
                             src="../../sprite/rank_grad_bg.png"
                             alt="">
                        <div class="top_three_box">
                            <div class="second_box top_three_common_class">
                                <img class="top_three_my_icon"
                                     v-if="topThree[1] && topThree[1].isMe"
                                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/7fc1c7eb47bf4fcfae4cc6337a198a89.png"
                                     alt="">
                                <img class="rank2"
                                     src="../../sprite/rank2.png"
                                     alt="">
                                <img class="avatar_url"
                                     :src="topThree[1] && topThree[1].groupAvatarUrl"
                                     alt="">
                                <img class="icon_rank2"
                                     src="../../sprite/icon_rank2.png"
                                     alt="">
                                <p class="user_nicker">{{topThree[1] && topThree[1].groupName}}</p>
                                <p class="commision"><span>{{topThree[1] && topThree[1].commissionOrderNumShort}}<span
                                              v-if="topThree[1] && topThree[1].commissionOrderNum>10000">万</span></span><span>单</span></p>
                            </div>
                            <div class="first_box top_three_common_class">
                                <img class="top_three_my_icon"
                                     v-if="topThree[0] && topThree[0].isMe"
                                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/7fc1c7eb47bf4fcfae4cc6337a198a89.png"
                                     alt="">
                                <img class="rank1"
                                     src="../../sprite/rank1.png"
                                     alt="">
                                <img class="avatar_url"
                                     :src="topThree[0] && topThree[0].groupAvatarUrl"
                                     alt="">
                                <img class="icon_rank1"
                                     src="../../sprite/icon_rank1.png"
                                     alt="">
                                <p class="user_nicker">{{topThree[0] && topThree[0].groupName}}</p>
                                <p class="commision"><span>{{topThree[0] && topThree[0].commissionOrderNumShort}}<span
                                              v-if="topThree[0] && topThree[0].commissionOrderNum>10000">万</span></span><span>单</span></p>
                            </div>
                            <div class="third_box top_three_common_class">
                                <img class="top_three_my_icon"
                                     v-if="topThree[2] && topThree[2].isMe"
                                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/7fc1c7eb47bf4fcfae4cc6337a198a89.png"
                                     alt="">
                                <img class="rank3"
                                     src="../../sprite/rank3.png"
                                     alt="">
                                <img class="avatar_url"
                                     :src="topThree[2] && topThree[2].groupAvatarUrl"
                                     alt="">
                                <img class="icon_rank3"
                                     src="../../sprite/icon_rank3.png"
                                     alt="">
                                <p class="user_nicker">{{topThree[2] && topThree[2].groupName}}</p>
                                <p class="commision"><span>{{topThree[2] && topThree[2].commissionOrderNumShort}}<span
                                              v-if="topThree[2] && topThree[2].commissionOrderNum>10000">万</span></span><span>单</span></p>
                            </div>
                        </div>
                        <div class="no_rank_data"
                             v-if="topThree.length == 0 && orderNumRankList.length == 0">暂无排行数据~</div>
                        <div class="table_box">
                            <div class="bodyIn">
                                <div class="tableBody"
                                     v-for="(item, index) in orderNumRankList"
                                     :key="index">
                                    <div class="rank_info">
                                        <img class="my_icon"
                                             v-if="item.isMe"
                                             src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/7fc1c7eb47bf4fcfae4cc6337a198a89.png"
                                             alt="">
                                        <img class="headImg"
                                             :src="item.groupAvatarUrl"
                                             alt="">
                                        <span class="name">{{item.groupName}}</span>
                                        <span class="rankNum">{{item.rank}}</span>
                                    </div>
                                    <div v-if="item.commissionOrderNum > 10000"
                                         class="money">{{item.commissionOrderNumShort}}万单</div>
                                    <div v-else
                                         class="money">{{item.commissionOrderNumShort}}单</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>
            <!-- 已加入战队提示popup -->
            <van-popup v-model="showJoinedPopup"
                       class="joined_team_popup">
                <img class="title_img"
                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/b42f84597eaf417faba396bc15b4c9b6.png"
                     alt="">
                <div class="joined_team_content">
                    <p class="invited_tip">是否加入</p>
                    <img class="invited_avatar"
                         :src="joinedInfos.groupAvatarUrl"
                         alt="">
                    <p class="invited_nick">{{joinedInfos.groupName}}</p>
                    <div class="btn_box">
                        <div class="cancel_btn"
                             @click="showJoinedPopup = false">我再想想</div>
                        <div class="confirm_btn"
                             @click="joinActivityGroup">确认加入</div>
                    </div>
                </div>
                <img class="close_img"
                     src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/224a30e535b145428899581767bb2ec2.png"
                     alt=""
                     @click="showJoinedPopup = false">
            </van-popup>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcode'
import {
    getToken,
    urlParse,
    isMangguoApp,
    MGTVVIP_page_view,
    MGTVVIP_click_event
} from '../../utils/tokenUtils'
import mgLoginInfo from '../../utils/mgLoginInfo'
import { CreateUserInfo } from '../../service/home'
import {
    GetDataTimeNow,
    GetActivityInfo,
    GetProductListByIds,
    GetIsJoinActivity,
    GetUserActivityInfo,
    GetActPrizeRecordInfo,
    JoinActivity,
    CreateActivityGroup,
    JoinActivityGroup,
    GetGroupInfo,
    GetActivityUser,
    GetGroupOrderNumRankList
} from '../../service/activityDetails'
import Rule from './rule.vue'
import './index.less'
export default {
    components: { Rule },
    data() {
        return {
            // 线上的
            ids1: [], // 活动商品id（佣金加码）
            ids2: [23750420115154, 23970420114750, 23910215100730, 23200215100356], // 活动商品id（组队冲榜）

            current: -1, // 当前活动标签
            // 当前活动页签id（佣金加码：[111230401, 111230501, 111230502, 111230503, 111230504]；组队冲榜：[111230402, 111230505]）
            currentId: 111230401,
            dateArr1: [], // 活动时间页签（佣金加码）
            activityArr1: [], // 5个时间段的聚合（佣金加码）
            dateArr2: [], // 活动时间页签（组队冲榜）
            activityArr2: [], // 2个时间段的聚合（组队冲榜）

            loading: false,
            Teamloading: false,
            isApp: isMangguoApp(),
            token: '',
            userInfo: {},
            isOutIn: false,
            isDisable: false, // 账号是否被禁用
            isAuthorized: false, // 是否授权初始化用户信息
            isVisible: false, // 授权弹窗显隐

            bonusCfg: [], // 进度条补贴门槛信息
            progressIn: 0,
            commissionOrderCount: 0, // 我的订单量（佣金加码）
            subsidyMoney: 0, // 补贴金（佣金加码）

            activityInfo: {}, // 活动信息
            activityInfo1: {}, // 活动信息（佣金加码）
            activityInfo2: {}, // 活动信息（组队冲榜）
            productList1: [], // 商品list（佣金加码）
            productList2: [], // 商品list（组队冲榜）

            teamInfos: {}, // 战队信息
            topThree: [], // 排名前三
            orderNumRankList: [],
            publicityStartDate: '2023-05-28 00:00:00', // 发奖公示开始时间
            publicityEndDate: '2023-05-28 23:59:59', // 发奖公示结束时间

            nowTime: 0, // 当前时间时间戳（到秒 10位）
            endPublicityTime: 0, // 发奖公示时间戳
            isPublicityTimeEnd: false, // 是否到发奖公示时间

            isActivityStart1: false, // 活动是否开始（佣金加码）
            isActivityEnd1: false, // 活动是否结束（佣金加码）
            isActivityEnd2: false, // 活动是否结束（组队冲榜）

            isJoinActivity1: false, // 是否已报名活动（佣金加码）
            isJoinActivity2: false, // 是否已报名活动（组队冲榜）

            showRulePopup: false, // 活动规则 popup
            showProductPopup: false, // 商品海报显隐
            shareProduct: {}, // 当前分享的商品对象信息

            showCreatTeamPopup: false, // 创建团队popup
            qrCode: '', // 邀请加入团队的二维码
            showInvitedJoinPopup: false, // 邀请加入组队popup
            showSalesRankPopup: false, // 团队销量排行popup

            joinedInfos: {}, // 已加入战队提示弹窗信息
            showJoinedPopup: false // 已加入战队提示popup
        }
    },
    computed: {},
    created() {
        this.endPublicityTime = new Date(
            this.publicityStartDate.replace(/-/g, '/')
        ).getTime()
        this.urlData = urlParse(window.location.href)
        console.log('---this.urlData', this.urlData)
        this.loading = true
        this.getDataTimeNow()
    },
    mounted() {
        mgLoginInfo(this, 'activityDetailsFive', this.urlData.type)
        setTimeout(() => {
            if (
                !this.urlData.type ||
                this.urlData.type == 101 ||
                this.urlData.type == 102 ||
                this.urlData.type == 103 ||
                this.urlData.type == 104 ||
                this.urlData.type == 105
            ) {
                this.current = 1
                this.activityInfo = this.activityInfo1
            }
            if (this.urlData.type == 201 || this.urlData.type == 202) {
                this.current = 2
                this.activityInfo = this.activityInfo2
            }
            // 埋点，会员数据上报（页面PV）
            let mgUuid = this.token ? this.userInfo.mgUuid : ''
            MGTVVIP_page_view(`${this.activityInfo.activityName}活动页`, mgUuid)
        }, 300)
    },
    methods: {
        async init() {
            let type = this.urlData.type
            // 佣金加码
            if (type == 101) {
                this.currentId = 111230401
            }
            if (type == 102) {
                this.currentId = 111230501
            }
            if (type == 103) {
                this.currentId = 111230502
            }
            if (type == 104) {
                this.currentId = 111230503
            }
            if (type == 105) {
                this.currentId = 111230504
            }
            await this.getActivityInfo_all()

            if (type == 201 || type == 202) {
                await this.getActivityInfo_all2()
            }
            // 组队冲榜
            if (type == 201) {
                this.currentId = 111230402
            }
            if (type == 202) {
                this.currentId = 111230505
            }

            if (this.token && this.isAuthorized) {
                await this.getIsJoinActivity(this.currentId)
            }
            await this.getActivityInfo(this.currentId)
            if (this.urlData.activityGroupId && (type == 201 || type == 202)) {
                await GetGroupInfo({
                    activityId: this.currentId,
                    activityGroupId: this.urlData.activityGroupId
                }).then((res) => {
                    const { code, data } = res
                    if (code == '0') {
                        this.joinedInfos = data || {}
                        if (data && data.groupMemberInfos) {
                            this.showJoinedPopup = !data.groupMemberInfos.some(
                                (item) => {
                                    return this.userInfo.id == item.userId
                                }
                            )
                        }
                    }
                })
            }
            this.loading = false
        },
        // 去登录
        goLogin() {
            const that = this
            if (isMangguoApp()) {
                MgtvApi.login(function (data) {
                    if (data.code == 200) {
                        mgLoginInfo(
                            that,
                            'activityDetailsFive',
                            this.urlData.type
                        )
                    }
                })
            } else {
                window.location.href = `https://m.mgtv.com/login/?from=${
                    process.env.NODE_ENV == 'development'
                        ? encodeURIComponent(window.location.href)
                        : encodeURIComponent(window.location.href)
                }`
            }
        },
        // 确认授权成为大使
        createUserInfo() {
            CreateUserInfo({
                token: localStorage.getItem('token'),
                channelCode: this.urlData.channelCode,
                superiorId: this.urlData.superiorId,
                shareId: this.urlData.shareId
            }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    localStorage.setItem('nickName', data.nickName)
                    localStorage.setItem('avatarUrl', data.avatarUrl)
                    localStorage.setItem('channelCode', data.channelCode)
                    localStorage.setItem('mgUuid', data.mgUuid)
                    localStorage.setItem('id', data.id)
                    localStorage.setItem('shareId', data.shareId)
                    localStorage.setItem('superiorId', data.superiorId)
                    localStorage.setItem('userLevel', data.userLevel)
                    this.isVisible = false
                    this.isAuthorized = true // 是否授权初始化用户信息
                    this.$toast('加盟成功')
                }
            })
        },
        // 点击 活动规则
        handleViewRule() {
            // this.$refs.refRule.isPromoteRuleShow = true
            this.showRulePopup = true
        },
        // 关闭活动规则
        handleCloseRulePopup() {
            this.showRulePopup = false
        },
        viewAgreement(e) {
            this.$router.push(e)
        },
        // 通过商品Ids获取商品信息（佣金加码）
        getProductListByIds1() {
            // this.ids1 = [22290816141208, 22430902181821, 22160923155552] // 自测用
            GetProductListByIds({
                ids: this.ids1
            }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    this.productList1 = data.list || []
                }
            })
        },
        // 通过商品Ids获取商品信息（组队冲榜）
        getProductListByIds2() {
            // this.ids2 = [22290816141208, 22430902181821, 22160923155552] // 自测用
            GetProductListByIds({
                ids: this.ids2
            }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    this.productList2 = data.list || []
                }
            })
        },
        // 获取当前时间时间戳（到秒 10位）
        getDataTimeNow() {
            GetDataTimeNow().then((res) => {
                const { code, data } = res
                if (code == '0') {
                    this.nowTime = Number('' + `${data}000`)
                }
            })
        },
        async getActivityInfo_all() {
            let obj1 = {},
                obj2 = {},
                obj3 = {},
                obj4 = {},
                obj5 = {},
                allobj1 = {},
                allobj2 = {},
                allobj3 = {},
                allobj4 = {},
                allobj5 = {}
            await GetActivityInfo({ activityId: 111230401 }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    let sT = new Date(
                        data.startTime.replace(/-/g, '/')
                    ).getTime() // 活动开始时间戳
                    if (this.nowTime < sT) {
                        obj1['isBegin'] = false // 活动未开启
                    }
                    if (this.nowTime >= sT) {
                        obj1['isBegin'] = true // 活动已开启
                    }
                    allobj1 = data || {}
                    obj1['id'] = data && data.id
                    obj1['startTime'] = data && data.startTime
                    obj1['endTime'] = data && data.endTime
                    obj1['actDate'] =
                        data &&
                        `${data.startTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}-${data.endTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}`
                }
            })
            await GetActivityInfo({ activityId: 111230501 }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    let sT = new Date(
                        data.startTime.replace(/-/g, '/')
                    ).getTime() // 活动开始时间戳
                    if (this.nowTime < sT) {
                        obj2['isBegin'] = false // 活动未开启
                    }
                    if (this.nowTime >= sT) {
                        obj2['isBegin'] = true // 活动已开启
                        this.currentId = data && data.id
                    }
                    allobj2 = data || {}
                    obj2['id'] = data && data.id
                    obj2['startTime'] = data && data.startTime
                    obj2['endTime'] = data && data.endTime
                    obj2['actDate'] =
                        data &&
                        `${data.startTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}-${data.endTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}`
                }
            })
            await GetActivityInfo({ activityId: 111230502 }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    let sT = new Date(
                        data.startTime.replace(/-/g, '/')
                    ).getTime() // 活动开始时间戳
                    if (this.nowTime < sT) {
                        obj3['isBegin'] = false // 活动未开启
                    }
                    if (this.nowTime >= sT) {
                        obj3['isBegin'] = true // 活动已开启
                        this.currentId = data && data.id
                    }
                    allobj3 = data || {}
                    obj3['id'] = data && data.id
                    obj3['startTime'] = data && data.startTime
                    obj3['endTime'] = data && data.endTime
                    obj3['actDate'] =
                        data &&
                        `${data.startTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}-${data.endTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}`
                }
            })
            await GetActivityInfo({ activityId: 111230503 }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    let sT = new Date(
                        data.startTime.replace(/-/g, '/')
                    ).getTime() // 活动开始时间戳
                    if (this.nowTime < sT) {
                        obj4['isBegin'] = false // 活动未开启
                    }
                    if (this.nowTime >= sT) {
                        obj4['isBegin'] = true // 活动已开启
                        this.currentId = data && data.id
                    }
                    allobj4 = data || {}
                    obj4['id'] = data && data.id
                    obj4['startTime'] = data && data.startTime
                    obj4['endTime'] = data && data.endTime
                    obj4['actDate'] =
                        data &&
                        `${data.startTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}-${data.endTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}`
                }
            })
            await GetActivityInfo({ activityId: 111230504 }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    // data.startTime = '2023-05-23 00:00:12' // 自测用
                    let sT = new Date(
                        data.startTime.replace(/-/g, '/')
                    ).getTime() // 活动开始时间戳
                    if (this.nowTime < sT) {
                        obj5['isBegin'] = false // 活动未开启
                    }
                    if (this.nowTime >= sT) {
                        obj5['isBegin'] = true // 活动已开启
                        this.currentId = data && data.id
                    }
                    allobj5 = data || {}
                    obj5['id'] = data && data.id
                    obj5['startTime'] = data && data.startTime
                    obj5['endTime'] = data && data.endTime
                    obj5['actDate'] =
                        data &&
                        `${data.startTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}-${data.endTime
                            .slice(6, 10)
                            .split('-')
                            .join('.')}`
                }
            })
            this.dateArr1 = [obj1, obj2, obj3, obj4, obj5]
            this.activityArr1 = [allobj1, allobj2, allobj3, allobj4, allobj5]
        },
        async getActivityInfo_all2() {
            let obj1 = {},
                obj2 = {},
                allobj1 = {},
                allobj2 = {}
            await GetActivityInfo({ activityId: 111230402 }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    let sT = new Date(
                        data.startTime.replace(/-/g, '/')
                    ).getTime() // 活动开始时间戳
                    if (this.nowTime < sT) {
                        obj1['isBegin'] = false // 活动未开启
                    }
                    if (this.nowTime >= sT) {
                        obj1['isBegin'] = true // 活动已开启
                    }
                    allobj1 = data || {}
                    obj1['id'] = data && data.id
                    obj1['startTime'] = data && data.startTime
                    obj1['endTime'] = data && data.endTime
                    obj1['actDate'] =
                        data &&
                        `${data.startTime
                            .slice(6, 10)
                            .split('-')
                            .join('月')}日-${data.endTime
                            .slice(6, 10)
                            .split('-')
                            .join('月')}日`
                }
            })
            await GetActivityInfo({ activityId: 111230505 }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    // data.startTime = '2023-05-10 00:00:12' // 自测用
                    let sT = new Date(
                        data.startTime.replace(/-/g, '/')
                    ).getTime() // 活动开始时间戳
                    if (this.nowTime < sT) {
                        obj2['isBegin'] = false // 活动未开启
                    }
                    if (this.nowTime >= sT) {
                        obj2['isBegin'] = true // 活动已开启
                        this.currentId = data && data.id
                    }
                    allobj2 = data || {}
                    obj2['id'] = data && data.id
                    obj2['startTime'] = data && data.startTime
                    obj2['endTime'] = data && data.endTime
                    obj2['actDate'] =
                        data &&
                        `${data.startTime
                            .slice(6, 10)
                            .split('-')
                            .join('月')}日-${data.endTime
                            .slice(6, 10)
                            .split('-')
                            .join('月')}日`
                }
            })
            this.dateArr2 = [obj1, obj2]
            this.activityArr2 = [allobj1, allobj2]
            // console.log('---dateArr2', this.dateArr2)
            // console.log('---activityArr2', this.activityArr2)
        },
        // 活动信息（佣金加码、组队冲榜）
        getActivityInfo(id) {
            GetActivityInfo({ activityId: id }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    // （佣金加码）
                    if (
                        id == 111230401 ||
                        id == 111230501 ||
                        id == 111230502 ||
                        id == 111230503 ||
                        id == 111230504
                    ) {
                        document.title = data && data.activityName
                        this.activityInfo = data || {}
                        this.activityInfo1 = data || {}
                        this.bonusCfg = (data && data.bonusCfg) || [] // 进度条补贴门槛信息
                        this.ids1 = (data && data.porductList) || [] // 活动商品id（佣金加码）
                        this.getProductListByIds1()
                        let sT = new Date(
                            data.startTime.replace(/-/g, '/')
                        ).getTime() // 活动开始时间戳
                        let eT = new Date(
                            data.endTime.replace(/-/g, '/')
                        ).getTime() // 活动结束时间戳
                        if (this.nowTime < sT) {
                            // console.log('活动未开始')
                            this.isActivityStart1 = false
                        }
                        if (this.nowTime >= sT) {
                            // console.log('活动已开始')
                            this.isActivityStart1 = true
                        }
                        // console.log('eT', eT)
                        // console.log('this.nowTime', this.nowTime)
                        // console.log('----活动', eT > this.nowTime)
                        if (this.nowTime <= eT) {
                            // console.log('活动未结束')
                            this.isActivityEnd1 = false
                        }
                        if (this.nowTime > eT) {
                            // console.log('活动已结束')
                            this.isActivityEnd1 = true
                        }
                    }

                    // （组队冲榜）
                    if (id == 111230402 || id == 111230505) {
                        document.title = data && data.activityName
                        let objs = JSON.parse(JSON.stringify(data || {}))
                        for (let k in objs) {
                            if (k == 'startTime' || k == 'endTime') {
                                objs[k] =
                                    objs[k].slice(6, 10).split('-').join('月') +
                                    '日'
                            }
                        }
                        this.activityInfo = data || {}
                        this.activityInfo2 = objs
                        this.ids2 = (data && data.porductList) || [] // 活动商品id（组队冲榜）
                        this.getProductListByIds2()
                        let eT = new Date(
                            data.endTime.replace(/-/g, '/')
                        ).getTime() // 活动结束时间戳
                        // console.log('eT', eT)
                        // console.log('this.nowTime', this.nowTime)
                        // console.log('----活动', eT > this.nowTime)
                        if (this.nowTime <= eT) {
                            // console.log('活动未结束')
                            this.isActivityEnd2 = false
                        }
                        if (this.nowTime > eT) {
                            // console.log('活动已结束')
                            this.isActivityEnd2 = true
                        }
                        if (this.token && this.isAuthorized) {
                            this.getGroupOrderNumRankList()
                            this.getActivityUser() // 根据活动Id获取组队Id
                        }
                    }
                }
            })
        },
        // 排行榜list
        getGroupOrderNumRankList() {
            this.topThree = []
            this.orderNumRankList = []
            GetGroupOrderNumRankList({ activityId: this.currentId }).then(
                (res) => {
                    const { code, data } = res
                    if (code == '0') {
                        data.list &&
                            data.list.forEach((item) => {
                                if (item.commissionOrderNum > 10000) {
                                    item.commissionOrderNumShort = (
                                        item.commissionOrderNum / 10000
                                    ).toFixed(2)
                                } else {
                                    item.commissionOrderNumShort =
                                        item.commissionOrderNum
                                }
                                // this.userInfo.id = 22170807101737 // 自测用
                                if (
                                    this.token &&
                                    item.masterUserId == this.userInfo.id
                                ) {
                                    this.$set(item, 'isMe', true)
                                }
                            })
                        if (data.list.length > 0) {
                            this.topThree = data.list.slice(0, 3)
                            this.orderNumRankList = data.list.slice(3, 30)
                        }
                        this.loading = false
                    } else {
                        this.loading = false
                    }
                }
            )
        },
        // 查询 是否已报名活动
        getIsJoinActivity(id) {
            GetIsJoinActivity({ activityId: id }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    // （佣金加码）
                    if (
                        id == 111230401 ||
                        id == 111230501 ||
                        id == 111230502 ||
                        id == 111230503 ||
                        id == 111230504
                    ) {
                        this.isJoinActivity1 = data
                        // this.isJoinActivity1 = true // 自测用
                        if (this.isJoinActivity1 == true) {
                            this.getUserActivityInfo(id)
                        }
                    }
                    // （组队冲榜）
                    if (id == 111230402 || id == 111230505) {
                        this.isJoinActivity2 = data
                    }
                }
            })
        },
        // 查询用户佣金/订单信息
        getUserActivityInfo(id) {
            GetUserActivityInfo({ activityId: id }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    // （佣金加码）
                    if (
                        id == 111230401 ||
                        id == 111230501 ||
                        id == 111230502 ||
                        id == 111230503 ||
                        id == 111230504
                    ) {
                        this.commissionOrderCount =
                            data.commissionOrderCount || 0
                        // this.commissionOrderCount = 2360 // 自测用
                        let resAmount = this.commissionOrderCount
                        let t1 = 0
                        let s1 = (100 / 7) * 2
                        let s2 = (100 / 7) * 2 + s1
                        let s3 = (100 / 7) * 2 + s2
                        let min0 =
                            this.bonusCfg &&
                            this.bonusCfg[0].orderCountMinRequired
                        let min1 =
                            this.bonusCfg &&
                            this.bonusCfg[1].orderCountMinRequired
                        let min2 =
                            this.bonusCfg &&
                            this.bonusCfg[2].orderCountMinRequired
                        let min3 = 0
                        if (id == 111230401) {
                            min3 = 2500
                        }
                        if (id == 111230501) {
                            min3 = 1800
                        }
                        if (id == 111230502 || id == 111230503) {
                            min3 = 1840
                        }
                        if (id == 111230504) {
                            min3 = 2360
                        }
                        // console.log('---resAmount', resAmount)
                        if (resAmount > 0) {
                            if (resAmount <= min0) {
                                this.progressIn =
                                    (((resAmount / min0) * 100) / 7) * 2
                            }
                            if (resAmount <= min1 && resAmount > min0) {
                                t1 = resAmount - min0
                                this.progressIn =
                                    (((t1 / (min1 - min0)) * 100) / 7) * 2 + s1
                            }
                            if (resAmount <= min2 && resAmount > min1) {
                                t1 = resAmount - min1
                                this.progressIn =
                                    (((t1 / (min2 - min1)) * 100) / 7) * 2 + s2
                            }
                            if (resAmount > min2) {
                                t1 = resAmount - min2
                                this.progressIn =
                                    (((t1 / (min3 - min2)) * 100) / 7) * 2 + s3
                            }
                        } else {
                            this.progressIn = 0
                        }
                        if (this.progressIn >= 100) {
                            this.progressIn = 98
                        }
                        if (this.progressIn < 0) {
                            this.progressIn = 1
                        }
                        // console.log('---this.progressIn', this.progressIn)

                        if (
                            this.bonusCfg &&
                            this.bonusCfg.length > 0 &&
                            this.commissionOrderCount >=
                                this.bonusCfg[0].orderCountMinRequired
                        ) {
                            this.getActPrizeRecordInfo(id)
                        }
                    }
                }
            })
        },
        // （佣金加码）补贴金
        getActPrizeRecordInfo(id) {
            GetActPrizeRecordInfo({ activityId: id }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    // （佣金加码）补贴金
                    this.subsidyMoney = (data && data.prizeAmount) || 0
                    console.log('this.subsidyMoney', this.subsidyMoney)
                }
            })
        },
        // 切换活动（佣金加码、组队冲榜）
        async handleCheckTab(t) {
            if (t == 101) {
                document.title =
                    this.activityInfo1 && this.activityInfo1.activityName
                this.current = 1
                this.currentId = 111230401
                await this.getActivityInfo_all() // 获取佣金加码的时间段
            }
            if (t == 201) {
                document.title =
                    this.activityInfo2 && this.activityInfo2.activityName
                this.current = 2
                this.currentId = 111230402
                await this.getActivityInfo_all2() // 获取组队冲榜的时间段
            }
            if (this.token && this.isAuthorized) {
                await this.getIsJoinActivity(this.currentId)
            }
            await this.getActivityInfo(this.currentId)
            console.log('---this.currentId', this.currentId)
        },
        // 切换时间页签
        async handleCheckDate(val) {
            // console.log('val：', val)
            await this.getDataTimeNow()
            let sT = new Date(val.startTime.replace(/-/g, '/')).getTime() // 活动开始时间戳
            if (this.nowTime < sT) {
                this.$toast('活动未开始，敬请期待~')
            }
            if (this.nowTime >= sT) {
                this.currentId = val.id
                this.getIsJoinActivity(val.id)
                this.getActivityInfo(val.id)
            }
        },
        // 立即报名（佣金加码）
        goJoin1() {
            if (this.isDisable) return
            if (!localStorage.getItem('token')) {
                this.goLogin()
                return
            }
            if (!this.isAuthorized) {
                this.isVisible = true
                return
            }
            if (!this.isActivityStart1)
                return this.$toast('活动未开始，敬请期待~')
            if (this.isActivityEnd1) return this.$toast('活动已结束~')
            if (this.currentId) {
                JoinActivity({ activityIds: [this.currentId] }).then((res) => {
                    const { code, data } = res
                    if (code == '0') {
                        this.getIsJoinActivity(this.currentId)
                        this.getActivityInfo(this.currentId)
                        this.$toast('报名成功，快去推广吧~')
                    }
                })
            }
        },

        // 生成海报
        shareHandle(item) {
            if (this.isDisable) return
            if (!localStorage.getItem('token')) {
                this.goLogin()
                return
            }
            if (!this.isAuthorized) {
                this.isVisible = true
                return
            }
            setTimeout(() => {
                // 埋点，会员数据上报（点击事件）
                MGTVVIP_click_event(
                    `${this.activityInfo.activityName}活动页-${item.productName}-点击商品分享赚`,
                    this.userInfo.mgUuid
                )
            }, 200)
            this.shareProduct = item
            this.showProductPopup = true
        },
        handleClose() {
            this.showProductPopup = false
        },
        // 去活动奖励页面
        goEventRewards() {
            this.$router.push({
                path: '/eventRewards'
            })
        },
        // 去发奖公示页面
        goAwardPlacard() {
            this.$router.push({
                path: '/awardPlacard',
                query: {
                    activityId: this.activityInfo2.id,
                    publicityStartDate: this.publicityStartDate,
                    publicityEndDate: this.publicityEndDate
                }
            })
        },
        // 点击 创建团队
        _showCreatTeamPopup() {
            if (this.isDisable) return
            if (!localStorage.getItem('token')) {
                this.goLogin()
                return
            }
            if (!this.isAuthorized) {
                this.isVisible = true
                return
            }
            this.showCreatTeamPopup = true
        },
        // 点击 创建
        async creatTeamHandle() {
            let params = {
                activityId: this.currentId,
                activityGroupName: `${this.userInfo.nickName} 的战队`
            }
            await CreateActivityGroup(params).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    this.getIsJoinActivity(this.currentId)
                    this.getGroupInfo(data && data.id)
                    this.$toast('创建成功~')
                } else {
                    this.$toast(res.message)
                }
                this.showCreatTeamPopup = false
            })
        },
        // 获取团队信息
        async getGroupInfo(activityGroupId) {
            this.Teamloading = true
            let params = {
                activityId: this.currentId,
                activityGroupId: activityGroupId
            }
            await GetGroupInfo(params).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    this.teamInfos = data || {}
                }
                this.Teamloading = false
            })
        },
        // 根据活动Id获取组队Id
        async getActivityUser() {
            await GetActivityUser({ activityId: this.currentId }).then(
                (res) => {
                    const { code, data } = res
                    if (code == '0' && data && data.activityGroupId) {
                        this.getGroupInfo(data.activityGroupId)
                    }
                }
            )
        },
        // 邀请好友组队
        invitiedFriendHanled() {
            this.showInvitedJoinPopup = true
            // 组队冲榜
            let type = ''
            if (this.currentId == 111230402) {
                type = 201
            }
            if (this.currentId == 111230505) {
                type = 202
            }
            let joinUrl =
                process.env.NODE_ENV == 'development'
                    ? `http://test.mgtv.com/tpl/mclub/#/activityDetailsFive?activityGroupId=${this.teamInfos.activityGroupId}&type=${type}`
                    : `https://lego.mgtv.com/tpl/mclub/#/activityDetailsFive?activityGroupId=${this.teamInfos.activityGroupId}&type=${type}`
            console.log('---joinUrl', joinUrl)
            QRCode.toDataURL(joinUrl, (err, qrcode) => {
                if (err) return console.log(err)
                this.qrCode = qrcode
            })
        },
        // 确认加入
        async joinActivityGroup() {
            if (this.isDisable) return
            if (!localStorage.getItem('token')) {
                this.goLogin()
                return
            }
            console.log('---***', this.isAuthorized)
            if (!this.isAuthorized) {
                this.isVisible = true
                return
            }
            await JoinActivityGroup({
                activityId: this.currentId,
                activityGroupId: this.urlData.activityGroupId
            }).then((res) => {
                const { code, data } = res
                if (code == '0') {
                    this.$toast(`已加入~`)
                    this.getIsJoinActivity(this.currentId)
                    this.getGroupInfo(this.urlData.activityGroupId)
                } else {
                    this.$toast(res.message)
                }
                this.showJoinedPopup = false
            })
        }
    }
}
</script>
<style lang="less" scoped>
</style>